export enum RefiDigitalEnum {
    OMNI_KEYCLOAK_DEFAULT = 'refi-digital',
    OMNI_KEYCLOAK_DEFAULT_BEBLUE = 'beblue',
    OMNI_KEYCLOAK_DEFAULT_PAGBEM = 'pagbem',
    OMNI_KEYCLOAK_DEFAULT_PORTOCRED = 'portocred',
    USERS_TERMS = 'https://www.omni.com.br/assets/upload/arquivos/20200624-TERMOS-DE-USO-E-POLITICA-DE-PRIVACIDADE-REFI.pdf',
    REDIRECT_REPLACE = 'login',
    REDIRECT_URI = 'saudacao'
}
